import React, { useEffect, useState } from "react";
import Axios from "../../../axios/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";
import SupplierNavbar from "../Admin/SuppplierNavbar";
import SupplierSidebar from "../Admin/SupplierSidebar";

function CreateEngProduct() {
  const [suppliers, setSuppliers] = useState([]);
  const [partName, setPartName] = useState([]);
  const [partNo, setPartNo] = useState("");
  const [supplier, setSupplier] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [manufacturer, setManufacturer] = useState("");

  const [engineeringModels, setEngineeringModels] = useState([]);
  const [engineeringBrands, setEngineeringBrands] = useState([]);
  const [engineeringCategories, setEngineeringCategories] = useState([]);
  const [year, setYear] = useState([]);
  const [engineeringregion, setRegion] = useState([]);
  const [productType, setProductTypeList] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [pricePerUnit, setPricePerUnit] = useState("");
  const [manufactureDate, setManufactureDate] = useState("");
  const [warrantyPeriod, setWarrantyPeriod] = useState("");
  const [material, setMaterial] = useState("");
  // const [catalogueFiles, setCatalogueFiles] = useState([]);
  const [compatibleModels, setCompatibleModels] = useState([]);
  const [features, setFeatures] = useState([]);
  const [certifications, setCertifications] = useState([]);
  const [images, setImages] = useState([]);
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({ selectedSupplier: {} });
  const [description, setDescription] = useState("");
  const [manufacturers, setManufacturers] = useState([]);

  useEffect(() => {
    const storedSupplier = sessionStorage.getItem("supplierInfo");
    if (storedSupplier) {
      const supplierInfo = JSON.parse(storedSupplier);
      setSupplier(supplierInfo);
    }
  }, []);

  useEffect(() => {
    const fetchLoggedInSupplier = async () => {
      try {
        const supplierInfo = JSON.parse(sessionStorage.getItem("supplierInfo"));

        if (!supplierInfo?.supplierId) {
          console.error("No supplier ID found");
          return;
        }

        const response = await Axios.get(
          `/supplier/get/${supplierInfo.supplierId}`
        );

        if (!response.data?.data) {
          console.error("No supplier data in response");
          return;
        }

        const apiData = response.data.data;

        setFormData((prev) => ({
          ...prev,
          selectedSupplier: {
            _id: apiData._id,
            supplierName: apiData.supplierName || "Not provided",
            address: apiData.address || "Not provided",
            phoneNumber: apiData.phoneNumber || "Not provided",
            emailAddress: apiData.emailAddress || "Not provided",
          },
        }));
      } catch (error) {
        console.error("Error fetching supplier:", error);
      }
    };

    fetchLoggedInSupplier();
  }, []);

  useEffect(() => {
    const fetchManufacturers = async () => {
      try {
        const response = await Axios.get("/manufacturer");
        setManufacturers(response.data); // assuming API returns an array
      } catch (error) {
        console.error("Error fetching manufacturers:", error);
      }
    };

    fetchManufacturers();
  }, []);

  const [errors, setErrors] = useState({
    model: "",
    feature: "",
    certification: "",
  });
  const [catalogueFile, setCatalogueFile] = useState({ title: "", url: "" });

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // set null values for input fields
  const [inputValues, setInputValues] = useState({
    model: "",
    feature: "",
    certification: "",
  });

  console.log(inputValues, "values ");

  useEffect(() => {
    const getCompleteData = async () => {
      try {
        const response = await Axios.get("/type-based-details");

        if (response.data?.engineering) {
          setEngineeringBrands(response.data.engineering.brands || []);
          setEngineeringModels(response.data.engineering.models || []);
          setEngineeringCategories(response.data.engineering.categories || []);
        } else {
          console.error("No engineering data found in API response.");
        }
      } catch (error) {
        console.error("Error fetching engineering data:", error);
      } finally {
        setLoading(false); // Stop loading after the fetch is done
      }
    };

    getCompleteData();
  }, []);

  // Update the upload handler:
  const uploadCatalogueFileHandler = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);

    try {
      const options = {
        maxSizeMB: 0.2,
        maxWidthOrHeight: 800,
        useWebWorker: true,
      };

      const compressedFile = await imageCompression(file, options);
      const formData = new FormData();
      formData.append("image", compressedFile);

      const config = { headers: { "Content-Type": "multipart/form-data" } };
      const { data } = await Axios.post("/upload-multiple", formData, config);

      setCatalogueFile({
        title: file.name,
        url: data.fileUrls[0],
      });
    } catch (error) {
      console.error("Error uploading catalogue file:", error);
      toast.error("Failed to upload catalogue file");
    } finally {
      setUploading(false);
    }
  };

  // Remove handler:
  const removeCatalogueFile = () => {
    setCatalogueFile({ title: "", url: "" });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log("Submitting with Supplier:", formData.selectedSupplier);

    if (
      !selectedModel ||
      !selectedBrand ||
      !selectedCategory ||
      !selectedRegion ||
      !formData.selectedSupplier?._id
    ) {
      toast.error("Please select all required fields.");
      return;
    }

    try {
      const supplierData = formData.selectedSupplier;

      const data = {
        partName,
        partNo,
        modelId: selectedModel,
        brandId: selectedBrand,
        categoryId: selectedCategory,
        year,
        regionId: selectedRegion,
        productType: selectedType,
        pricePerUnit,
        manufactureDate,
        warrantyPeriod,
        material,
        catalogue: catalogueFile,
        manufacturer,
        compatibleModels,
        features,
        certifications,
        images,
        description,
        supplier: {
          supplierId: supplierData._id,
          name: supplierData.supplierName,
          location: supplierData.address,
          contactNumber: supplierData.phoneNumber,
          email: supplierData.emailAddress,
        },
      };

      console.log("Submitting FormData:", data);

      await Axios.post("/engineeringpart/create", data);
      toast.success("Engineering part created successfully!");
      setTimeout(() => {
        navigate("/SupplierProducts");
      }, 1000);
    } catch (error) {
      console.error(
        "Error creating engineering part:",
        error.response || error.message
      );
    }
  };

  const uploadFileHandler = async (e, val) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    setUploading(true);

    try {
      const uploadedImages = await Promise.all(
        Array.from(files).map(async (file) => {
          // Compress image (optional)
          const compressedFile = await imageCompression(file, {
            maxSizeMB: 0.2,
            maxWidthOrHeight: 800,
          });

          const formData = new FormData();
          formData.append("image", compressedFile);

          const { data } = await Axios.post("/upload-multiple", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          return {
            name: file.name,
            url: data.fileUrls[0], // Assuming backend returns URLs
            public_id: data.public_id, // For Cloudinary (optional)
          };
        })
      );

      setImages([...images, ...uploadedImages]); // Append new images
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Failed to upload images");
    } finally {
      setUploading(false);
    }
  };

  const removeImage = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1); // Remove image at index
    setImages(updatedImages);
  };

  const handleAdd = (key) => {
    if (!inputValues[key]?.trim()) {
      setErrors({ ...errors, [key]: "Enter something!" });
      return;
    }

    if (key === "model") {
      setCompatibleModels([...compatibleModels, inputValues[key]]);
    } else if (key === "feature") {
      setFeatures([...features, inputValues[key]]);
    } else if (key === "certification") {
      setCertifications([...certifications, inputValues[key]]);
    }

    setInputValues({ ...inputValues, [key]: "" });
    setErrors({ ...errors, [key]: "" }); // Clear error after successful addition
  };

  const handleRemove = (key, index) => {
    if (key === "model") {
      setCompatibleModels(compatibleModels.filter((_, i) => i !== index));
    } else if (key === "feature") {
      setFeatures(features.filter((_, i) => i !== index));
    } else if (key === "certification") {
      setCertifications(certifications.filter((_, i) => i !== index));
    }
  };

  useEffect(() => {
    const fetchSuppliers = async () => {
      try {
        const response = await Axios.get("/supplier");
        setSuppliers(response.data.data);
      } catch (error) {
        console.error("Error fetching suppliers:", error.message);
      }
    };
    fetchSuppliers();
  }, []);

  const handleSupplierChange = (e) => {
    const supplierId = e.target.value;
    const supplier = suppliers.find((sup) => sup._id === supplierId);

    console.log("Selected Supplier:", supplier);

    setFormData((prev) => ({
      ...prev,
      selectedSupplier: supplier || {},
    }));
  };

  useEffect(() => {
    console.log("Updated formData:", formData);
  }, [formData]);

  const handleCancel = () => {
    navigate("/SupplierProducts");
  };

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        const response = await Axios.get("/regions");
        setRegion(response.data);
      } catch (error) {
        console.error("Error fetching regions:", error);
      }
    };

    fetchRegions();
  }, []);

  useEffect(() => {
    const fetchProductType = async () => {
      try {
        const response = await Axios.get("/type-based-details");

        if (response.data && typeof response.data === "object") {
          // Map API response keys to match enum values
          const formattedTypes = Object.keys(response.data).map((type) => {
            if (type === "engineering") return "Engineering";
            if (type === "building") return "Building";
            if (type === "spare") return "Auto-Spare";
            return type; // Fallback
          });

          setProductTypeList(formattedTypes);
        } else {
          setProductTypeList([]); // Fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching product type:", error);
        setProductTypeList([]); // Fallback to empty array
      }
    };

    fetchProductType();
  }, []);

  const handleChange = (e) => {
    setSelectedType(e.target.value);
  };

  return (
    <div className="enhanced-body">
      <SupplierNavbar
        supplier={supplier}
        setSupplier={setSupplier}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />
      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
              <SupplierSidebar />
            </div>
          )}
          <div className={sidebarOpen ? "col-md-10" : "col-md-12"}>
            <div className="row dashboard-main">
              <div className="col-12 grid-margin stretch-card">
                <div
                  className="card"
                  style={{
                    maxHeight: "95vh",
                    overflowY: "auto",
                    minHeight: "90vh",
                  }}
                >
                  <div className="card-body">
                    <h4 className="card-title">Create Engineering Part</h4>
                    <form className="forms-sample" onSubmit={handleSubmit}>
                      <div className="form-group">
                        <label>Part Name</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => setPartName(e.target.value)}
                          placeholder="Enter Part Name"
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Part Number</label>
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => setPartNo(e.target.value)}
                          placeholder="Enter Part Number"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Description</label>
                        <textarea
                          className="form-control"
                          rows="4"
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                          placeholder="Enter Description"
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Brand</label>
                        <select
                          className="form-control"
                          value={selectedBrand}
                          onChange={(e) => {
                            console.log("Selected Brand:", e.target.value);
                            setSelectedBrand(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Brand</option>
                          {engineeringBrands.map((brand) => (
                            <option key={brand._id} value={brand._id}>
                              {brand.name}
                            </option>
                          ))}
                        </select>
                        {/* <p>
                  Selected Brand:{" "}
                  {engineeringBrands.find((b) => b._id === selectedBrand)
                    ?.name || "None"}
                </p> */}
                      </div>

                      <div className="form-group">
                        <label>Model</label>
                        <select
                          className="form-control"
                          value={selectedModel}
                          onChange={(e) => setSelectedModel(e.target.value)}
                          required
                        >
                          <option value="">Select Model</option>
                          {engineeringModels.map((model) => (
                            <option key={model._id} value={model._id}>
                              {model.name}
                            </option>
                          ))}
                        </select>
                        {/* <p>
                  Selected Model:{" "}
                  {engineeringModels.find((m) => m._id === selectedModel)
                    ?.name || "None"}
                </p> */}
                      </div>

                      <div className="form-group">
                        <label>Category</label>
                        <select
                          className="form-control"
                          value={selectedCategory}
                          onChange={(e) => setSelectedCategory(e.target.value)}
                          required
                        >
                          <option value="">Select Category</option>
                          {engineeringCategories.map((category) => (
                            <option key={category._id} value={category._id}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                        {/* <p>
                  Selected Category:{" "}
                  {engineeringCategories.find((c) => c._id === selectedCategory)
                    ?.name || "None"}
                </p> */}
                      </div>

                      <div className="form-group">
                        <label>Region</label>
                        <select
                          className="form-control"
                          value={selectedRegion}
                          onChange={(e) => setSelectedRegion(e.target.value)}
                          required
                        >
                          <option value="">Select Region</option>
                          {engineeringregion.map((region) => (
                            <option key={region._id} value={region._id}>
                              {region.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>year</label>
                        <input
                          type="number"
                          placeholder="Enter year"
                          className="form-control"
                          onChange={(e) => setYear(Number(e.target.value))}
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Product Type</label>
                        <select
                          className="form-control"
                          value={selectedType}
                          onChange={handleChange}
                        >
                          <option value="">Select Product Type</option>
                          {/* Use dynamically fetched product types */}
                          {productType.map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="form-group">
                        <label>Price Per Unit</label>
                        <input
                          type="number"
                          placeholder="Enter Price per Unit"
                          className="form-control"
                          onChange={(e) =>
                            setPricePerUnit(Number(e.target.value))
                          }
                          required
                        />
                      </div>
                      <div className="form-group">
                        <label>Manufacturer</label>
                        <select
                          className="form-control"
                          value={manufacturer}
                          onChange={(e) => setManufacturer(e.target.value)}
                          required
                        >
                          <option value="">Select Manufacturer</option>
                          {manufacturers.map((m) => (
                            <option key={m._id} value={m._id}>
                              {m.manufacturerName}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Manufacture Date</label>
                        <input
                          type="date"
                          placeholder="Enter Manufacturing Date"
                          className="form-control"
                          onChange={(e) => setManufactureDate(e.target.value)}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Warranty Period</label>
                        <input
                          type="number"
                          placeholder="Enter Warranty Period"
                          className="form-control"
                          onChange={(e) => setWarrantyPeriod(e.target.value)}
                          required
                        />
                      </div>

                      <div className="form-group">
                        <label>Material</label>
                        <input
                          type="text"
                          placeholder="Enter Material"
                          className="form-control"
                          onChange={(e) => setMaterial(e.target.value)}
                          required
                        />
                      </div>

                      <div>
                        {/* Compatible Models */}
                        <div className="form-group">
                          <label>Compatible Models</label>
                          <div className="d-flex">
                            <input
                              type="text"
                              placeholder="Add Compatible Models"
                              className="form-control"
                              value={inputValues.model}
                              onChange={(e) =>
                                setInputValues({
                                  ...inputValues,
                                  model: e.target.value,
                                })
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-primary mx-2"
                              onClick={() => handleAdd("model")}
                            >
                              Add
                            </button>
                          </div>
                          {errors.model && (
                            <small className="text-danger">
                              {errors.model}
                            </small>
                          )}
                          <ul>
                            {compatibleModels.map((model, index) => (
                              <li key={index}>
                                {model}
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm mx-2"
                                  onClick={() => handleRemove("model", index)}
                                >
                                  Remove
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>

                        {/* Features */}
                        <div className="form-group">
                          <label>Features</label>
                          <div className="d-flex">
                            <input
                              type="text"
                              placeholder="Add Features"
                              className="form-control"
                              value={inputValues.feature}
                              onChange={(e) =>
                                setInputValues({
                                  ...inputValues,
                                  feature: e.target.value,
                                })
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-primary mx-2"
                              onClick={() => handleAdd("feature")}
                            >
                              Add
                            </button>
                          </div>
                          {errors.feature && (
                            <small className="text-danger">
                              {errors.feature}
                            </small>
                          )}
                          <ul>
                            {features.map((feature, index) => (
                              <li key={index}>
                                {feature}
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm mx-2"
                                  onClick={() => handleRemove("feature", index)}
                                >
                                  Remove
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>

                        {/* Certifications */}
                        <div className="form-group">
                          <label>Certifications</label>
                          <div className="d-flex">
                            <input
                              type="text"
                              placeholder="Add Certifications"
                              className="form-control"
                              value={inputValues.certification}
                              onChange={(e) =>
                                setInputValues({
                                  ...inputValues,
                                  certification: e.target.value,
                                })
                              }
                            />
                            <button
                              type="button"
                              className="btn btn-primary mx-2"
                              onClick={() => handleAdd("certification")}
                            >
                              Add
                            </button>
                          </div>
                          {errors.certification && (
                            <small className="text-danger">
                              {errors.certification}
                            </small>
                          )}
                          <ul>
                            {certifications.map((certification, index) => (
                              <li key={index}>
                                {certification}
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm mx-2"
                                  onClick={() =>
                                    handleRemove("certification", index)
                                  }
                                >
                                  Remove
                                </button>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>

                      {/* <div className="form-group">
                <label>Image</label>
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => uploadFileHandler(e, "photo")}
                />
                {uploading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Uploading...</span>
                  </div>
                ) : (
                  image && <img src={image.url} alt="Preview" height="100" />
                )}
              </div> */}

                      <div className="form-group">
                        <label>Images</label>
                        <div className="d-flex align-items-center mb-2">
                          <input
                            type="file"
                            id="image-upload"
                            className="d-none"
                            multiple // Allow multiple files
                            onChange={uploadFileHandler}
                            accept="image/*"
                          />
                          <label
                            htmlFor="image-upload"
                            className="btn btn-primary btn-sm mb-0"
                          >
                            <i className="icon-plus"></i> Add Images
                          </label>
                        </div>

                        {/* Show uploading spinner */}
                        {uploading && (
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="sr-only">Uploading...</span>
                          </div>
                        )}

                        {/* Display uploaded images */}
                        <div className="d-flex flex-wrap gap-2 mt-2">
                          {images.map((img, index) => (
                            <div key={index} className="position-relative">
                              <img
                                src={img.url}
                                alt={img.name}
                                height="80"
                                className="rounded border"
                              />
                              <button
                                type="button"
                                className="btn btn-danger btn-xs position-absolute top-0 end-0"
                                onClick={() => removeImage(index)}
                              >
                                ×
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* <div className="form-group">
                <label>Catalogue</label>
                <input
                  type="file"
                  className="form-control"
                  accept=".jpg, .jpeg, .png"
                  onChange={(e) => uploadCatalogueFileHandler(e, "photo1")}
                /> */}
                      {/* {uploading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Uploading...</span>
                  </div>
                ) : (
                  catalogueFiles.map((file, index) => (
                    <div key={index}>
                      <a
                        href={file.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {file.title}
                      </a>
                      <button
                        type="button"
                        onClick={() => removeCatalogueFile(file.url)}
                      >
                        Delete
                      </button>
                    </div>
                  ))
                )} */}

                      {/* {uploading ? (
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Uploading...</span>
                  </div>
                ) : (
                  catalogueFiles && (
                    <img src={catalogueFiles.url} alt="Preview" height="100" />
                  )
                )}
              </div>  */}

                      <div className="form-group">
                        <label>Catalogue</label>
                        <input
                          type="file"
                          className="form-control"
                          accept=".jpg, .jpeg, .png, .pdf"
                          onChange={uploadCatalogueFileHandler}
                        />

                        {uploading ? (
                          <div className="spinner-border" role="status">
                            <span className="sr-only">Uploading...</span>
                          </div>
                        ) : (
                          catalogueFile.url && (
                            <div className="mt-2">
                              <a
                                href={catalogueFile.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="d-block mb-1"
                              >
                                {catalogueFile.title}
                              </a>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={removeCatalogueFile}
                              >
                                Remove
                              </button>
                            </div>
                          )
                        )}
                      </div>

                      <label>Supplier</label>

                      {/* Supplier Information (read-only) */}
                      <input
                        type="text"
                        className="form-control mt-2"
                        value={
                          formData.selectedSupplier?.supplierName ||
                          "Loading..."
                        }
                        placeholder="Supplier Name"
                        readOnly
                      />
                      <input
                        type="text"
                        className="form-control mt-2"
                        value={formData.selectedSupplier?.address || ""}
                        placeholder="Location"
                        readOnly
                      />
                      <input
                        type="text"
                        className="form-control mt-2"
                        value={formData.selectedSupplier?.phoneNumber || ""}
                        placeholder="Contact Number"
                        readOnly
                      />
                      <input
                        type="email"
                        className="form-control mt-2"
                        value={formData.selectedSupplier?.emailAddress || ""}
                        placeholder="Email"
                        readOnly
                      />

                      <button
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={loading}
                      >
                        {loading ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          "Submit"
                        )}
                      </button>

                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      <div style={{ marginBottom: "60px" }}></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
      </div>{" "}
    </div>
  );
}

export default CreateEngProduct;
